var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 15.000021157434094 13.999993033879491",
    width: 15.000021157434094,
    height: 13.999993033879491,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.0000044420869584616, -6.080205783298709e-16) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.99885,9.02846h-0.69509l-0.24636,-0.2216c1.05584,-1.14901 1.60135,-2.71659 1.3022,-4.38266c-0.41354,-2.28161 -2.45482,-4.10361 -4.91844,-4.38266c-3.72182,-0.42678 -6.85414,2.495 -6.39661,5.96665c0.29915,2.29802 2.25245,4.2021 4.69847,4.58784c1.78612,0.27905 3.46666,-0.2298 4.69847,-1.21467l0.23756,0.2298v0.64837l3.73942,3.48807c0.36074,0.3365 0.95025,0.3365 1.311,0c0.36074,-0.3365 0.36074,-0.88638 0,-1.22288zM5.71967,9.02846c-2.19086,0 -3.95939,-1.64965 -3.95939,-3.69325c0,-2.0436 1.76853,-3.69325 3.95939,-3.69325c2.19086,0 3.95939,1.64965 3.95939,3.69325c0,2.0436 -1.76853,3.69325 -3.95939,3.69325z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(0, 74, 93)"
    },
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-168561768350797774",
    d: "M10.99885,9.02846h-0.69509l-0.24636,-0.2216c1.05584,-1.14901 1.60135,-2.71659 1.3022,-4.38266c-0.41354,-2.28161 -2.45482,-4.10361 -4.91844,-4.38266c-3.72182,-0.42678 -6.85414,2.495 -6.39661,5.96665c0.29915,2.29802 2.25245,4.2021 4.69847,4.58784c1.78612,0.27905 3.46666,-0.2298 4.69847,-1.21467l0.23756,0.2298v0.64837l3.73942,3.48807c0.36074,0.3365 0.95025,0.3365 1.311,0c0.36074,-0.3365 0.36074,-0.88638 0,-1.22288zM5.71967,9.02846c-2.19086,0 -3.95939,-1.64965 -3.95939,-3.69325c0,-2.0436 1.76853,-3.69325 3.95939,-3.69325c2.19086,0 3.95939,1.64965 3.95939,3.69325c0,2.0436 -1.76853,3.69325 -3.95939,3.69325z",
    vectorEffect: "non-scaling-stroke"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.d7fe90f7548fbfb3aa872088c1277fb1.svg";
export { ForwardRef as ReactComponent };